import { useContext, useCallback } from 'react';
import { AjaxContext, AppContext } from 'commons-ui';

import { MANDATE_REFUND_ENDPOINTS } from './constants';

/**
 * Execute stays open until every batch has been sent, which is a call to the
 * payment service plus a three second pause per 25 rows. The default two minutes
 * is not enough for a full batch.
 */
const EXECUTE_TIMEOUT_MS = 10 * 60 * 1000;

const useService = () => {
	const { postData } = useContext(AjaxContext);
	const {
		app: { appName }
	} = useContext(AppContext);

	const post = useCallback(
		(endpoint: string, file: File, timeout?: number) => {
			const formData = new FormData();
			formData.append('csv', file);
			return postData({
				endpoint,
				body: formData,
				queryParams: { appName },
				timeout,
				customHeaders: { 'Content-Type': 'multipart/form-data' }
			});
		},
		[appName]
	);

	/** Read only. A csv of uids in, the refundable rows and the exclusions out. */
	const resolve = useCallback((file: File) => post(MANDATE_REFUND_ENDPOINTS.RESOLVE, file), [post]);

	/** Moves money. The input.csv from resolve in, the outcome of every row out. */
	const execute = useCallback((file: File) => post(MANDATE_REFUND_ENDPOINTS.EXECUTE, file, EXECUTE_TIMEOUT_MS), [post]);

	return { resolve, execute };
};

export default useService;
